import React, { useEffect } from 'react';
import 'resize-observer-polyfill/dist/ResizeObserver.global';
import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { routeComponents } from './Config/RouteConfig';
import Layout from './Components/Layouts/Layout';
import PageNotFound from './Components/FieldComponets/PageNotFound';
import 'react-datepicker/dist/react-datepicker.css';

import "react-datepicker/dist/react-datepicker.css";
import Login from './Components/Auth/Login';
import { url } from './Config/Config';
import ForgotPassword from './Components/Auth/ForgotPassword';
import ResetPassword from './Components/Auth/ResetPassword';
import { useDispatch } from 'react-redux';
import { AdminDetailProfileAction } from './Redux/Action/AuthAction';
import { getItemFromStorage } from './utils/Helper';
import { StorageConstant } from './Constants/Constants';
import PrivateRoute from './router/PrivateRoute';


function App() {

  const dispatch = useDispatch<any>();

  useEffect(() => {
    if (getItemFromStorage(StorageConstant?.is_admin_login_token) !== null) {
      dispatch(AdminDetailProfileAction({}))
    }
  }, [])
  return (
    <> 
      <BrowserRouter basename="">
      

        <Routes>
          <Route element={<PrivateRoute component={Layout} />}>
            {routeComponents}
          </Route>
          <Route path={url + "/"} element={<Login />}></Route>
          <Route path={url + "forgot-password"} element={<ForgotPassword />}></Route>
          <Route path={url + "reset-password"} element={<ResetPassword />}></Route>
          <Route path={url + '*'} element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App
